var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f1f1;}.b{fill:#888;fill-rule:evenodd;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.42,2.75a1.911,1.911,0,0,0-1.286.487A1.6,1.6,0,0,0,5.6,4.415v.527H3.821A1.748,1.748,0,0,0,2,6.606v5.479A1.748,1.748,0,0,0,3.821,13.75h9.6a1.748,1.748,0,0,0,1.821-1.665V6.606a1.748,1.748,0,0,0-1.821-1.665H11.64V4.415a1.6,1.6,0,0,0-.534-1.178A1.91,1.91,0,0,0,9.82,2.75ZM10.4,4.941V4.415a.5.5,0,0,0-.169-.372.609.609,0,0,0-.41-.155H7.42a.61.61,0,0,0-.41.155.5.5,0,0,0-.169.372v.527ZM6.841,6.079H10.4v6.533H6.841Zm-1.241,0H3.821a.555.555,0,0,0-.579.527v5.479a.555.555,0,0,0,.579.527H5.6Zm6.041,6.533V6.079h1.779A.555.555,0,0,1,14,6.606v5.479a.555.555,0,0,1-.579.527Z",
    transform: "translate(6 7.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.39acb5fbbfdfe787cd748d2f168d788a.svg";
export { ForwardRef as ReactComponent };